// extracted by mini-css-extract-plugin
export var animationContainer = "_iz-0";
export var asteriskIcon = "_iz-8";
export var conversationLeftSection = "_iz-4";
export var conversationListItem = "_iz-3";
export var conversationMiddleSection = "_iz-5";
export var conversationRightSection = "_iz-6";
export var detailsContent = "_iz-1";
export var listContainer = "_iz-7";
export var modalContent = "_iz-2";